var mshopProductPage = (function()
{
    /**
    * 
    */
    var _configuration;
    var _selectedProductId;
    var _fancyBoxOptions;
    var _fancyBoxSlides;
    var _swiper = null;
    var _isDesktop;
    var _loadedReviews;
    var _isSavingReview;
	var _isSavingStockReminder;
	var _flyOutShowOffset;
	var _flyOutVisible;
	var _isSavingQuestion;

    /**
     *
     */
	var $_addToCartButton;
	var $_addToCartArea;
	var $_addToCartFormProduct;
	var $_addToCartAdwordsProduct;
	var $_addToCartPriceRunnerProduct;
	var $_imageGallery;
	var $_loadMoreReviewsBar;
	var $_loadMoreReviewsButton;
	var $_loadMoreReviewsHint;
	var $_loadMoreReviewsProgress;
	var $_mainImage;
	var $_outOfStockReminder;
	var $_outOfStockReminderButton;
	var $_outOfStockReminderEmail;
	var $_outOfStockReminderForm;
	var $_outOfStockReminderMessage;
	var $_productPrice;
	var $_productRating;
	var $_productStock;
	var $_reviews;
	var $_selectedVariantName;
	var $_thumbnails;
	var $_variants;
	var $_writeReviewCallout;
	var $_writeReviewFormBody;
	var $_writeReviewFormBodyContainer;
	var $_writeReviewFormBodyMessage;
	var $_writeReviewFormBodyShadow;
	var $_writeReviewFormButton;
	var $_writeReviewFormMessage;
	var $_writeReviewFormName;
	var $_writeReviewFormNameContainer;
	var $_writeReviewFormNameMessage;
	var $_writeReviewFormRating;
	var $_writeReviewCustomerServiceMessage;
	var $_writeReviewFormTitle;
	var $_writeReviewFormTitleContainer;
	var $_writeReviewFormTitleMessage;
    var $_accordionReviewsInput;
    var $_writeReviewArea;
    var $_writeReviewButton;
    var $_writeReviewForm;
	var $_salesHint;
	var $_accordionInputs;

	// Fly-out
	var $_flyOut;
	var $_flyOutImage;
	var $_flyOutPrice;
	var $_flyOutButton;
	var $_flyOutBadge;

	// Questionaire
	var $_askQuestionButton;
	var $_askQuestionForm;
	var $_askQuestionFormButton;
	var $_askQuestionMessage;
	var $_questionVoteButtons;
	var $_questionFormEmail;
	var $_questionFormBody;
	var $_questionFormBodyMessage;
	var $_questionFormEmailMessage;
	var $_questionFormEmailField;
	var $_questionFormBodyField;

    /**
    * Executed one page is loaded
    */
    function boot()
    {
		_isDesktop = XmxApp.isDesktop(); 
        _configuration = window.naeProductConfiguration;
    	_selectedProductId = _configuration.selectedProductId;
    	_loadedReviews = Math.min(_configuration.reviewSummary.totalReviews, _configuration.reviewSummary.pageSize);
    	_isSavingReview = false;
		_isSavingQuestion = false;
		_isSavingStockReminder = false;

        // Settings for the fancy box
        _fancyBoxOptions =
        {
            loop: true,

            // 1/5 and previous/next buttons on top
            infobar: true, 

            // buttons in the top right corner
            buttons: true, 

            // What buttons should appear in the toolbar
            slideShow: false,
            fullScreen: false,
            thumbs: false,
            closeBtn: true,

            // Enable gestures (tap, zoom, pan and pinch)
            touch: true,

            // Enable keyboard navigation
            keyboard: true,

            // Try to focus on first focusable element after opening
            focus: true,

            // Close when clicked outside of the content
            closeClickOutside: true
        };

        // Hook the add to cart button
		$_addToCartButton = jQuery('#add-to-cart-button');
		$_addToCartArea = jQuery('#add-to-cart-area');
		$_addToCartFormProduct = jQuery('#add-to-cart-form-product');
		$_addToCartAdwordsProduct = jQuery('#add-to-cart-form-adwords-product');
		$_addToCartPriceRunnerProduct = jQuery('#add-to-cart-form-pricerunner-product');

		// Hook out of stock area
		$_outOfStockReminder = jQuery('#out-of-stock-reminder');
		$_outOfStockReminderForm = jQuery('#out-of-stock-reminder-form');
		$_outOfStockReminderForm.on('submit', onOutOfStockFormSubmit);
		$_outOfStockReminderButton = jQuery('#out-of-stock-reminder-button');
		$_outOfStockReminderEmail = jQuery('#out-of-stock-reminder-email');
		$_outOfStockReminderMessage = jQuery('#out-of-stock-reminder-message');

    	// Make the star rating header clickable
    	$_accordionReviewsInput = jQuery('#accordion-reviews');
		$_productRating = jQuery('#product-rating');
		$_productRating.on('click', onProductRatingClick);

		// Hook all accordions
		$_accordionInputs = jQuery('.xmx-accordion-input');
		$_accordionInputs.on('change', onAccordionInputChange);

		// Make the variants clickable
		$_variants = jQuery('#product-variants > .xmx-product-variation');
		$_variants.on('click', onVariantClick);

		// Hook the variant name
		$_selectedVariantName = jQuery('#selected-variant-name');

		// Hook the stock
		$_productStock = jQuery('#product-stock');

		// Hook the price
		$_productPrice = jQuery('#product-price');

		// Hook the thumbnails and main image
		$_thumbnails = jQuery('#thumbnails');
		$_mainImage = jQuery('#main-image');
		$_imageGallery = jQuery('#image-gallery');

		// Hook the review area
		$_reviews = jQuery('#reviews');
		$_loadMoreReviewsHint = jQuery('#load-more-reviews-hint');
		$_loadMoreReviewsBar = jQuery('#load-more-reviews-bar');
		$_loadMoreReviewsProgress = jQuery('#load-more-reviews-progress');
		$_loadMoreReviewsButton = jQuery('#load-more-reviews-button');
		$_loadMoreReviewsButton.on('click', onLoadMoreReviewsButtonClick);

        // Make the "Write Review" button clickable
        $_writeReviewArea = jQuery('#write-review-area');
        $_writeReviewCallout = jQuery('#write-review-callout');
        $_writeReviewButton = jQuery('#write-review-button');
        $_writeReviewButton.on('click', onWriteReviewButtonClick);
        $_writeReviewFormButton = jQuery('#write-review-form-button');
        $_writeReviewForm = jQuery('#write-review-form');
    	$_writeReviewForm.on('submit', onWriteReviewFormSubmit);

		// Review Customer Service Message
		$_writeReviewCustomerServiceMessage = jQuery('#write-review-customer-service-message');

    	// Review Form Star Rating
		$_writeReviewFormRating = jQuery('#write-review-form-rating');
		$_writeReviewFormRating.on('change', onWriteReviewFormRatingChange);

		// Review Form Name Input
		$_writeReviewFormName = jQuery('#write-review-form-name');
		$_writeReviewFormName.on('paste', onWriteReviewFormNameInteraction);
		$_writeReviewFormName.on('keyup', onWriteReviewFormNameInteraction);
		$_writeReviewFormName.on('keydown', onWriteReviewFormNameInteraction);
		$_writeReviewFormName.on('blur', onWriteReviewFormNameInteraction);

		// Review Form Title Input
		$_writeReviewFormTitle = jQuery('#write-review-form-title');
		$_writeReviewFormTitle.on('paste', onWriteReviewFormTitleInteraction);
		$_writeReviewFormTitle.on('keyup', onWriteReviewFormTitleInteraction);
		$_writeReviewFormTitle.on('keydown', onWriteReviewFormTitleInteraction);
		$_writeReviewFormTitle.on('blur', onWriteReviewFormTitleInteraction);

		// Review Form Body Text Area
		$_writeReviewFormBodyShadow = jQuery('#write-review-form-body-shadow');
		$_writeReviewFormBody = jQuery('#write-review-form-body');
		$_writeReviewFormBody.on('paste', onWriteReviewFormBodyInteraction);
		$_writeReviewFormBody.on('keyup', onWriteReviewFormBodyInteraction);
		$_writeReviewFormBody.on('keydown', onWriteReviewFormBodyInteraction);
		$_writeReviewFormBody.on('blur', onWriteReviewFormBodyInteraction);

		// Validation messages
		$_writeReviewFormNameMessage = $_writeReviewFormName.parent().next();
		$_writeReviewFormTitleMessage = $_writeReviewFormTitle.parent().next();
		$_writeReviewFormBodyMessage = $_writeReviewFormBody.parent().next();

		// Input field wraps
		$_writeReviewFormNameContainer = $_writeReviewFormName.parent().parent();
		$_writeReviewFormTitleContainer = $_writeReviewFormTitle.parent().parent();
		$_writeReviewFormBodyContainer = $_writeReviewFormBody.parent().parent();

		// Success message
		$_writeReviewFormMessage = jQuery('#write-review-form-message');

		// Add-to-cart fly-out
		$_flyOut = jQuery('#cta-flyout');
		$_flyOutImage = jQuery('#cta-flyout-thumbnail-image');
		$_flyOutBadge = jQuery('#cta-flyout-badge');
		$_flyOutPrice = jQuery('#cta-flyout-price');
		$_flyOutButton = jQuery('#cta-flyout-button');
		$_flyOutButton.on('click', onFlyOutButtonClick);
	
		var $verticalTabs = jQuery('#vertical-tabs');

		if ($verticalTabs.length > 0)
		{
			_flyOutShowOffset = $verticalTabs.offset().top + 96;
		}
		else 
		{
			_flyOutShowOffset = 2000;
		}

		_flyOutVisible = false;

		if (!_configuration.isPreOrder)
		{
			// Hook the scroll observer 
			XmxApp.registerScrollEventObserver('product', handleScroll);
		}
		
		// Qty. sold
		$_salesHint = jQuery('#product-sales');

		// Hook the questionaire
		$_askQuestionButton = jQuery('#ask-question-button');
		$_askQuestionButton.on('click', onAskQuestionButtonClick);
		$_askQuestionForm = jQuery('#ask-question-form');
		$_askQuestionForm.on('submit', onAskQuestionFormSubmit);
		$_askQuestionFormButton = jQuery('#ask-question-form-button');
		$_askQuestionMessage = jQuery('#ask-question-message');
		$_questionVoteButtons = jQuery('[data-question-vote-button]');
		$_questionVoteButtons.on('click', onQuestionVoteButtonClick);
		$_questionFormEmail = jQuery('#ask-question-form-email');
		$_questionFormBody = jQuery('#ask-question-form-body');
		$_questionFormBodyMessage = jQuery('#ask-question-form-body-message');
		$_questionFormEmailMessage = jQuery('#ask-question-form-email-message');
		$_questionFormBodyField = jQuery('#ask-question-form-body-field');
		$_questionFormEmailField = jQuery('#ask-question-form-email-field');

        // Start the gallery
	    updateGallery();
		sendStockAlerts();
		
		// If the visitor is coming from Google Adwords or PriceRunner, update the price
		if (XmxApp.isComingFromGoogleAdwords() || XmxApp.isComingFromPriceRunner())
		{
			updatePrice();
		}
		
		// Update sales int
		updateSalesHint();

		// Update the flyout
		updateFlyout();

		// Send view impression to Google Analytics 4
		// For config products, send the parent and the selected child
		if (_configuration.productType == 'configurable')
		{
			sendGoogleAnalyticsView([_configuration.productId, _configuration.selectedProductId]);

			// Send Impressions to ourselves
			/*global XmxEventQueue*/
			XmxEventQueue.trackEvent('pv', 
			{
				'p': _configuration.productId,
				's': _configuration.productData[_configuration.productId].isInStock
			});

			XmxEventQueue.trackEvent('pv', 
			{
				'p': _configuration.selectedProductId,
				's': _configuration.productData[_configuration.selectedProductId].isInStock
			});
		}
		else 
		{
			sendGoogleAnalyticsView([_configuration.selectedProductId]);

			// Send Impressions to ourselves
			/*global XmxEventQueue*/
			XmxEventQueue.trackEvent('pv', 
			{
				'p': _configuration.selectedProductId,
				's': _configuration.productData[_configuration.selectedProductId].isInStock
			});
		}

		// Clerk is not loaded yet

		//initializeRecovery();
    }

	function onAccordionInputChange()
	{
		var $input = jQuery(this);
		var accordionId = $input.data('accordion-id');

		/*global XmxEventQueue*/
		XmxEventQueue.trackEvent('pac', 
		{
			'p': _selectedProductId,
			'a': accordionId
		});
	}

	/**
	 * Sends a product impression to Clerk
	 */
	function sendClerkProductView(productId)
	{
		if (XmxApp.supportsClerk())
		{
			Clerk.call
			(
				'log/product',
				{
					key: window.naeAppConfig.clerkApiKey,
					product: productId
				}
			);
		}
	}

	/**
	 * 
	 */
	/*function initializeRecovery()
	{
		var enableRecoverey = false;
		var googleClickId = XmxApp.extractHttpGetParameter('gclid');

		if (googleClickId != '')
		{
			enableRecoverey = true;
		}
		else 
		{
			if (document.referrer != '')
			{
				if (document.referrer.indexOf('.google.') != -1)
				{
					enableRecoverey = true;
				}
				else 
				{
					if (document.referrer.indexOf('.m-shop.') != -1)
					{
						enableRecoverey = true;
					}
				}
			}
		}

		if (enableRecoverey)
		{
			if (typeof window.history !== 'undefined')
			{
				window.history.pushState({ product: _selectedProductId }, document.title, document.location.href);

				window.addEventListener('popstate', function(event) 
				{
					event.preventDefault();
					event.stopPropagation();

					window.location = '/clerk/product/alternative?id=' + _selectedProductId;

					return false;
				});
			}
		}
	}*/

	/**
	 * Customer has changed the rating of the write review form
	 */
	function onWriteReviewFormRatingChange()
	{
		var rating = parseInt($_writeReviewFormRating.val());

		if (rating <= 3)
		{
			$_writeReviewCustomerServiceMessage.show();
		}
		else 
		{
			$_writeReviewCustomerServiceMessage.hide();
		}
	}

	/**
	 * Sends the view event to Google Analytics 4
	 * 
	 * @param array productIds
	 */
	function sendGoogleAnalyticsView(productIds)
	{
		var items = [];
		var value = 0;

		for (var i in productIds)
		{
			var productId = productIds[i];
			var productData = _configuration.productData[productId];

			items.push(
			{
				item_id: productData['sku'],
				item_name: productData['name'],
				price: productData['finalPriceExclVat'],
				quantity: 1
			});

			value += productData['finalPriceExclVat'];
		}

		window.dataLayer = window.dataLayer || [];
		window.dataLayer.push({ ecommerce: null }); 
		window.dataLayer.push(
		{
			event: 'view_item',
			ecommerce: 
			{
				currency: window.naeAppConfig.currencyCode,
				value: value,
				items: items
			}
		});
	}

	/**
	 * User wants to see the "ask a question section"
	 */
	function onAskQuestionButtonClick()
	{
		$_askQuestionButton.hide();
		$_askQuestionForm.show();
	}

	/**
	 * User wants to submit a question
	 * 
	 * @param {Event} event 
	 */
	function onAskQuestionFormSubmit()
	{
    	var email;
    	var body;
    	var hasValidationErrors = false;

		// Grab the email
		email = $_questionFormEmail.val().trim();

		// If the email is not empty, validate it
		if (email != '')
		{
			var emailValidationError = XmxApp.validateEmailAddress(email);

			if (emailValidationError != '')
			{
				$_questionFormEmailMessage.html(emailValidationError);
				$_questionFormEmailField.addClass('xmx-form-field--error');
				$_questionFormEmailField.addClass('xmx-form-field--show-message');
				hasValidationErrors = true;
			}
		}

		// Remove email message, if we have no problem here
		if (!hasValidationErrors)
		{
			$_questionFormEmailMessage.html('');
			$_questionFormEmailField.removeClass('xmx-form-field--error');
			$_questionFormEmailField.removeClass('xmx-form-field--show-message');
		}

		// Check that the body is present
		body = $_questionFormBody.val().trim();

		if (body == '')
		{
			$_questionFormBodyMessage.html(_configuration.translations.reviewMinLength); // = write a little more
			$_questionFormBodyField.addClass('xmx-form-field--error');
			$_questionFormBodyField.addClass('xmx-form-field--show-message');
			hasValidationErrors = true;
		}
		else 
		{
			$_questionFormBodyMessage.html('');
			$_questionFormBodyField.removeClass('xmx-form-field--error');
			$_questionFormBodyField.removeClass('xmx-form-field--show-message');
		}

		// If we have validation errors, get the hell out of here
		if (hasValidationErrors)
		{
			return false;
		}

    	// If we are already saving the question, abort
		if (_isSavingQuestion)
    	{
			return false;
    	}

    	// Remember that we are saving the question
		_isSavingQuestion = true;

    	// Disable the button and show the loading bubbles
    	$_askQuestionFormButton.attr('disabled', true);
		$_askQuestionFormButton.addClass('xmx-button--loading');

    	// Get some new questions
		jQuery.ajax
		({
			url: '/ajax/product/askQuestion',
			dataType: 'json',
			type: 'post',
			data:
			{
				'productId': _configuration.productId,
				'storeId': _configuration.storeId,
				'email': email,
				'question': body
			},
			success: function(response)
			{
				if (response.success)
				{
					// Reset the form
					$_questionFormEmail.val('');
					$_questionFormBody.val('');

					// And disable it
					$_questionFormEmail.attr('disabled', true);
					$_questionFormBody.attr('disabled', true);

					// Show the message
					$_askQuestionFormButton.hide();
					$_askQuestionMessage.show();
				}
			},
			complete: function()
			{
				// We are not saving anymore
				_isSavingQuestion = false;

				// Enable the button and hide the loading bubbles
				$_askQuestionFormButton.attr('disabled', false);
				$_askQuestionFormButton.removeClass('xmx-button--loading');
			}
		});

		return false;
	}
	
	/**
	 * User has clicked a question vote button
	 */
	function onQuestionVoteButtonClick()
	{
		var $button = jQuery(this);
		var $question = $button.closest('.xmx-question');
		var buttonDirection = $button.data('question-vote-button');
		var questionId = $question.data('question-id');
		var votedDirection = $question.data('voted');
		var $upVoteButton = jQuery('[data-question-vote-button="up"]', $question);
		var $downVoteButton = jQuery('[data-question-vote-button="down"]', $question);
		var $upVoteButtonLabel = jQuery('.xmx-button-label', $upVoteButton);
		var $downVoteButtonLabel = jQuery('.xmx-button-label', $downVoteButton);
		var upVotes = $upVoteButtonLabel.data('question-up-votes');
		var downVotes = $downVoteButtonLabel.data('question-down-votes');
		var newDirection = 'none';

		if (votedDirection == 'none')
		{
			votedDirection = null;
		}

		if (votedDirection == null)
		{
			// We have never voted yet
			if (buttonDirection == 'up')
			{
				// Add an up vote
				upVotes++;
				newDirection = 'up';
			}
			else 
			{
				// Add a down vote
				downVotes++;
				newDirection = 'down';
			}
		}
		else 
		{
			// We have already voted
			if (buttonDirection == votedDirection)
			{
				newDirection = 'none';

				// We want to undo a vote
				if (buttonDirection == 'up')
				{
					// Undo an up vote
					upVotes--;
				}
				else 
				{
					// Undo a down vote
					downVotes--;
				}
			}
			else 
			{
				// We want to change votes
				if (buttonDirection == 'up')
				{
					// Change to up vote
					upVotes++;
					downVotes--;
					newDirection = 'up';
				}
				else 
				{
					// Change to down vote
					downVotes++;
					upVotes--;
					newDirection = 'down';
				}
			}
		}

		$upVoteButtonLabel.data('question-up-votes', upVotes);
		$upVoteButtonLabel.html(upVotes);
		$downVoteButtonLabel.data('question-down-votes', downVotes);
		$downVoteButtonLabel.html(downVotes);
		$question.data('voted', newDirection);

		if (newDirection == 'up')
		{
			$upVoteButton.addClass('xmx-button--voted');
		}
		else 
		{
			$upVoteButton.removeClass('xmx-button--voted');
		}

		if (newDirection == 'down')
		{
			$downVoteButton.addClass('xmx-button--voted');
		}
		else 
		{
			$downVoteButton.removeClass('xmx-button--voted');
		}

		// Fire and forget
		jQuery.ajax
		({
			url: '/ajax/product/voteQuestion',
			dataType: 'json',
			type: 'post',
			data:
			{
				'productId': _configuration.productId,
				'storeId': _configuration.storeId,
				'questionId': questionId,
				'direction': newDirection
			}
		});
	}

	/**
	 * Updates the Fly-Out
	 */
	function updateFlyout()
	{
		var productData = _configuration.productData[_selectedProductId];
		var finalPrice = productData.finalPrice;
		var basePrice = productData.basePrice;

		if (XmxApp.isComingFromGoogleAdwords())
		{
			if (productData.adwordsPrice)
			{
				if (productData.adwordsPrice < finalPrice)
				{
					finalPrice = productData.adwordsPrice;
				}
			}
		}

		if (XmxApp.isComingFromPriceRunner())
		{
			if (productData.priceRunnerPrice)
			{
				if (productData.priceRunnerPrice < finalPrice)
				{
					finalPrice = productData.priceRunnerPrice;
				}
			}
		}

		// Re-calculate the base price
		if (productData.baseUnitContent > 0)
		{
			basePrice = finalPrice / productData.baseUnitContent;
		}

		// Empty the price
		$_flyOutPrice.empty();

		// Rebuild-the price
		var $price = jQuery('<div>');
		$price.addClass('xmx-price');
		$price.appendTo($_flyOutPrice);
		
		// Is there a special price?
		if (finalPrice < productData.price)
		{
			var $specialPrice = jQuery('<div>');
			$specialPrice.addClass('xmx-price-new');
			$specialPrice.html(XmxApp.formatAmount(finalPrice));
			$specialPrice.appendTo($price);

			// Can be to wide, so lets use classic %
			var savingPercent = finalPrice <= 0 ? 100 : 100 - Math.round(finalPrice * 100 / productData.price);

			var $discount = jQuery('<div>');
			$discount.addClass('xmx-price-discount');
			$discount.html('-' + savingPercent + '%');
			$discount.appendTo($price);
		}
		else 
		{
			var $regularPrice = jQuery('<div>');
			$regularPrice.addClass('xmx-price-reguar');
			$regularPrice.html(XmxApp.formatAmount(finalPrice));
			$regularPrice.appendTo($price);
		}

		// Update the base price
		if (basePrice > 0)
		{
			var $unitPrice = jQuery('<div>');
			$unitPrice.addClass('xmx-price-unit');

			if (productData.baseUnitValue == 1)
			{
				$unitPrice.html(XmxApp.formatAmount(basePrice) + ' / ' + productData.baseUnitMeasure);
			}
			else 
			{
				$unitPrice.html(XmxApp.formatAmount(basePrice) + ' / ' + XmxApp.formatUnit(productData.baseUnitValue, productData.baseUnitMeasure));
			}

			$unitPrice.appendTo($_flyOutPrice);
		}

		// Update the image
		if (productData.images.length > 0)
		{
			$_flyOutImage.attr('src', productData.images[0].mobileThumbnailUrl);
		}

		// Figure out if there is a badge
		var badgeText = null;

		// Empty the badge container
		$_flyOutBadge.empty();

		if (productData.stockColor == 'red')
		{
			badgeText = productData.stockLabel;
		}

		if (badgeText != null)
		{
			var $badge = jQuery('<div>');
			$badge.addClass('xmx-badge');
			$badge.addClass('xmx-badge--special');
			$badge.html(badgeText);
			$badge.appendTo($_flyOutBadge)
		}
	}

	/**
	 * CTA Fly-Out Button pressed
	 */
	function onFlyOutButtonClick()
	{
		$_addToCartButton.click();
	}
	
	/**
	 * Called on scroll
	 */
	function handleScroll()
	{
		var scrollPosition = XmxApp.scrollOffsetY;

		if (scrollPosition > _flyOutShowOffset)
		{
			if (!_flyOutVisible)
			{
				$_flyOut.addClass('xmx-cta-flyout--visible');
				_flyOutVisible = true;
			}
		}
		else 
		{
			if (_flyOutVisible)
			{
				$_flyOut.removeClass('xmx-cta-flyout--visible');
				_flyOutVisible = false;
			}
		}
	}

	/**
	 * 
	 */
	function updateSalesHint()
	{
		// If there is no sales info, get out of here
		if (_configuration.sales === null)
		{
			return;
		}

		var elapsedHours = (XmxApp.getCurrentTimestamp() - _configuration.sales.time) / (60 * 60);
		var quantitySold = Math.floor(_configuration.sales.quantity + _configuration.sales.speed * elapsedHours);
		var hint = _configuration.translations.salesInfo.replace('$1', quantitySold);

		$_salesHint.html(hint);
		$_salesHint.show();
	}

    /**
     * Sends an alert if the visitor comes from Google Adwords and sees an out of stock
     * product.
     */
    function sendStockAlerts()
    {
    	var googleClickId;

    	if (_configuration.isCompletelyOutOfStock)
    	{
			jQuery.ajax
			({
				url: '/ajax/product/logOutOfStockProductView',
				dataType: 'json',
				type: 'post',
				data:
				{
					'productId': _selectedProductId,
					'storeId': _configuration.storeId,
					'url': window.location.href
				}
			});

    		// Google Adwords
    		googleClickId = XmxApp.extractHttpGetParameter('gclid');

    		if (googleClickId != '')
    		{
				jQuery.ajax
				({
					url: '/ajax/product/googleAdwordsAlert',
					dataType: 'json',
					type: 'post',
					data:
					{
						'productId': _selectedProductId,
						'storeId': _configuration.storeId,
						'url': window.location.href,
						'clickId': googleClickId
					}
				});
    		}
    	}
    }

    /**
     * A user is submitting the "please send me an email once its back" form
     */
    function onOutOfStockFormSubmit()
    {
    	var email = $_outOfStockReminderEmail.val().trim();

    	// No realy validation for now
    	if (email == '')
    	{
    		return false;
    	}

    	// If we are already saving things, get out of here
    	if (_isSavingStockReminder)
    	{
    		return false;
    	}

    	_isSavingStockReminder = true;

    	// Disable the button and show the loading bubbles
    	$_outOfStockReminderButton.attr('disabled', true);
    	$_outOfStockReminderButton.addClass('xmx-button--loading');

    	// Post the data
		jQuery.ajax
		({
			url: '/ajax/product/postStockReminder',
			dataType: 'json',
			type: 'post',
			data:
			{
				'productId': _selectedProductId,
				'storeId': _configuration.storeId,
				'email': email
				// TODO: checksum
			},
			success: function(response)
			{
				if (response.success)
				{
					// Reset the form
					$_outOfStockReminderEmail.val('');

					// Hide the form
					$_outOfStockReminderForm.hide();

					// Show the message
					$_outOfStockReminderMessage.addClass('xmx-message--visible');
				}
			},
			complete: function()
			{
				// We are not saving anymore
				_isSavingStockReminder = false;

				// Disable the button and hide the loading bubbles
				$_outOfStockReminderButton.attr('disabled', false);
				$_outOfStockReminderButton.removeClass('xmx-button--loading');
			}
		});

    	return false;
    }

    /**
     * The user has submittedthe "Post Review" form
     *
     * This solution is not elegant, but does the job for now
     */
    function onWriteReviewFormSubmit()
    {
    	var rating;
    	var name;
    	var title;
    	var body;
    	var hasValidationErrors = false;
    	var minimumBodyLength = $_writeReviewFormBody.data('cool-length');

    	// The rating is always present, since its a star rating
    	rating = $_writeReviewFormRating.val();

    	// Check that the name is present
		name = $_writeReviewFormName.val().trim();

		if (name == '')
		{
			$_writeReviewFormNameMessage.html(_configuration.translations.pleaseEnterAName);
			$_writeReviewFormNameContainer.addClass('xmx-form-field--error');
			$_writeReviewFormNameContainer.addClass('xmx-form-field--show-message');
			hasValidationErrors = true;
		}
		else 
		{
			$_writeReviewFormNameContainer.removeClass('xmx-form-field--error');
			$_writeReviewFormNameContainer.removeClass('xmx-form-field--show-message');
		}

		// Check that the title is present
		title = $_writeReviewFormTitle.val().trim();

		if (title == '')
		{
			$_writeReviewFormTitleMessage.html(_configuration.translations.pleaseEnterATitle);
			$_writeReviewFormTitleContainer.addClass('xmx-form-field--error');
			$_writeReviewFormTitleContainer.addClass('xmx-form-field--show-message');
			hasValidationErrors = true;
		}
		else 
		{
			$_writeReviewFormTitleContainer.removeClass('xmx-form-field--error');
			$_writeReviewFormTitleContainer.removeClass('xmx-form-field--show-message');
		}

		// Check that the body is present
		body = $_writeReviewFormBody.val().trim();

		if (body == '')
		{
			$_writeReviewFormBodyMessage.html(_configuration.translations.pleaseEnterABody);
			$_writeReviewFormBodyContainer.addClass('xmx-form-field--error');
			$_writeReviewFormBodyContainer.addClass('xmx-form-field--show-message');
			hasValidationErrors = true;
		}
		else 
		{
			// Check that the body is of minimum length
			if (body.length < minimumBodyLength)
			{
				$_writeReviewFormBodyMessage.html(_configuration.translations.pleaseEnterALongerBody);
				$_writeReviewFormBodyContainer.addClass('xmx-form-field--error');
				$_writeReviewFormBodyContainer.addClass('xmx-form-field--show-message');
				hasValidationErrors = true;
			}
			else 
			{
				$_writeReviewFormBodyContainer.removeClass('xmx-form-field--error');
				$_writeReviewFormBodyContainer.removeClass('xmx-form-field--show-message');
			}
		}

		// If we have validation errors, get the hell out of here
		if (hasValidationErrors)
		{
			return false;
		}

    	// If we are already saving the review, abort
    	if (_isSavingReview)
    	{
			return false;
    	}

    	// Remember that we are saving the review
    	_isSavingReview = true;

    	// Disable the button and show the loading bubbles
    	$_writeReviewFormButton.attr('disabled', true);
    	$_writeReviewFormButton.addClass('xmx-button--loading');

    	// Get some new reviews
		jQuery.ajax
		({
			url: '/ajax/product/postReview',
			dataType: 'json',
			type: 'post',
			data:
			{
				'productId': _configuration.productId,
				'storeId': _configuration.storeId,
				'rating': rating,
				'name': name,
				'title': title,
				'body': body
			},
			success: function(response)
			{
				if (response.success)
				{
					// Reset the form
					$_writeReviewFormRating.val(5);
					$_writeReviewFormName.val('');
					$_writeReviewFormTitle.val('');
					$_writeReviewFormBody.val('');

					// And disable it
					$_writeReviewFormRating.attr('disabled', true);
					$_writeReviewFormName.attr('disabled', true);
					$_writeReviewFormTitle.attr('disabled', true);
					$_writeReviewFormBody.attr('disabled', true);

					// Show the message
					$_writeReviewFormButton.hide();
					$_writeReviewFormMessage.show();

					// Hide the customer service message
					$_writeReviewCustomerServiceMessage.hide();
				}
			},
			complete: function()
			{
				// We are not saving anymore
				_isSavingReview = false;

				// Disable the button and hide the loading bubbles
				$_writeReviewFormButton.attr('disabled', false);
				$_writeReviewFormButton.removeClass('xmx-button--loading');
			}
		});

		return false;
    }

    /** 
     * Called after the user has done something with the review form name
     */
    function onWriteReviewFormNameInteraction()
    {
    	// Update the length indicator
    	updateInputFieldLengthIndicator($_writeReviewFormName);

    	// Remove the error message
		$_writeReviewFormNameContainer.removeClass('xmx-form-field--error');
		$_writeReviewFormNameContainer.removeClass('xmx-form-field--show-message');
    }

    /** 
     * Called after the user has done something with the review form title
     */
    function onWriteReviewFormTitleInteraction()
    {
    	// Update the length indicator
    	updateInputFieldLengthIndicator($_writeReviewFormTitle);

    	// Remove the error message
		$_writeReviewFormTitleContainer.removeClass('xmx-form-field--error');
		$_writeReviewFormTitleContainer.removeClass('xmx-form-field--show-message');
    }

    /** 
     * Called after the user has done something with the review form title
     */
    function onWriteReviewFormBodyInteraction()
    {
    	// Update the length indicator
    	updateTextareaLengthIndicator($_writeReviewFormBody);
    	updateReviewFormTextareaSize();

    	// Remove the error message
		$_writeReviewFormBodyContainer.removeClass('xmx-form-field--error');
		$_writeReviewFormBodyContainer.removeClass('xmx-form-field--show-message');
    }

    /**
     * Updates the size of the review form body. The same "could" be done
     * with the contenteditable="true", but nah..
     */
    function updateReviewFormTextareaSize()
    {
    	var content;
    	var height;

    	// Get the content from the text area
    	content = $_writeReviewFormBody.val();

    	// Replace all line breaks
    	content = content.replace(/\n/g, '<br>');

    	// Add one more character, as the last line break at the 
    	// end of the string does not seem to count
    	content += '<br>a';

    	// Copy over the content from the text area to the shadow
    	$_writeReviewFormBodyShadow.html(content);

    	// Measure the height of the shadow
    	height = $_writeReviewFormBodyShadow.outerHeight();

    	// And set the height of the text area
    	$_writeReviewFormBody.css('height', height + 'px');
    }

	/**
	 * Updates the length indicator of an input field
	 */
	function updateTextareaLengthIndicator($textarea)
	{
		var coolLength = $textarea.data('cool-length');
		var awesomeLength = $textarea.data('awesome-length');
		var rockstarLength = $textarea.data('rockstar-length');
		var length = $textarea.val().trim().length;
		var $indicator = $textarea.next();

		if (length >= rockstarLength)
		{
			$indicator.html(_configuration.translations.reviewRockstarLength + ' (' + length + ' / ' + coolLength + ')');
		}
		else 
		{
			if (length >= awesomeLength)
			{
				$indicator.html(_configuration.translations.reviewAwesomeLength + ' (' + length + ' / ' + coolLength + ')');
			}
			else 
			{
				if (length >= coolLength)
				{
					$indicator.html(_configuration.translations.reviewCoolLength + ' (' + length + ' / ' + coolLength + ')');
				}
				else 
				{
					$indicator.html(_configuration.translations.reviewMinLength + ' (' + length + ' / ' + coolLength + ')');
				}
			}
		}
	}

	/**
	 * Updates the length indicator of an input field
	 */
	function updateInputFieldLengthIndicator($inputField)
	{
		var maxLength = $inputField.attr('maxlength');
		var length = $inputField.val().trim().length;
		var $indicator = $inputField.next();

		$indicator.html(length + ' / ' + maxLength);
	}

    /**
     * The user has clicked the "Load More Reviews" button
     */
    function onLoadMoreReviewsButtonClick()
    {
		var addedReviews = 0;

		jQuery('.xmx-review:hidden', $_reviews).each(function()
		{
			var $review = jQuery(this);
			$review.show();

			addedReviews++;

			// Add 8 more reviews max
			if (addedReviews == 8)
			{
				return false;
			}
		});

		_loadedReviews += addedReviews;

		// If we have loaded all reviews, hide the "load more" area
		if (_loadedReviews >= _configuration.reviewSummary.totalReviews)
		{
			// Hide the progress bar
			$_loadMoreReviewsProgress.hide();

			// "No more reviews to load"
			$_loadMoreReviewsHint.html(_configuration.translations.noMoreReviewsToLoad);

			// Hide le button
			$_loadMoreReviewsButton.hide();
		}
		else 
		{
			// Calculate the %
			var loadedPercent = _loadedReviews * 100 / _configuration.reviewSummary.totalReviews;

			// Update the progress bar
			$_loadMoreReviewsBar.css('width', loadedPercent + '%');

			// Update the hint
			$_loadMoreReviewsHint.html(_configuration.translations.reviewProgress.replace('%1', _loadedReviews).replace('%2', _configuration.reviewSummary.totalReviews));
		}
    }

    /**
     * Updates the price UI
     */
    function updatePrice()
    {
    	var productData = _configuration.productData[_selectedProductId];

    	// Throw away the old info
    	$_productPrice.empty();

		// If the product is out of stock and discontinued, dont show the price
		if (!productData.isInStock && productData.isDiscontinued)
		{
			return;
		}

		var finalPrice = productData.finalPrice;
		var price = productData.price;
		var basePrice = productData.basePrice;
		var msrp = productData.msrp;

		$_addToCartAdwordsProduct.val(0);

		if (XmxApp.isComingFromGoogleAdwords())
		{
			if (productData.adwordsPrice)
			{
				if (productData.adwordsPrice < finalPrice)
				{
					finalPrice = productData.adwordsPrice;
					$_addToCartAdwordsProduct.val(1); 

					// Re-calculate the base price
					if (productData.baseUnitContent > 0)
					{
						basePrice = finalPrice / productData.baseUnitContent;
					}
				}
			}
		}

		$_addToCartPriceRunnerProduct.val(0);

		if (XmxApp.isComingFromPriceRunner())
		{
			if (productData.priceRunnerPrice)
			{
				if (productData.priceRunnerPrice < finalPrice)
				{
					finalPrice = productData.priceRunnerPrice;
					$_addToCartPriceRunnerProduct.val(1);

					// Re-calculate the base price
					if (productData.baseUnitContent > 0)
					{
						basePrice = finalPrice / productData.baseUnitContent;
					}
				}
			}
		}


		// Price
		var $priceDisplay = document.createElement('div');
		$priceDisplay.classList.add('xmx-price-display');
		$priceDisplay.classList.add('xmx-price-display--large');
		$_productPrice[0].appendChild($priceDisplay);

		var $priceLine1 = document.createElement('div');
		$priceLine1.classList.add('xmx-price-line');
		$priceLine1.classList.add('xmx-price-line--final');
		$priceDisplay.appendChild($priceLine1);

		var $finalPriceAmount = document.createElement('div');
		$finalPriceAmount.classList.add('xmx-price-final-amount');
		$finalPriceAmount.innerText = XmxApp.formatAmount(finalPrice);
		$priceLine1.appendChild($finalPriceAmount);

		var previousPriceLabel = null;
		var previousPrice = null;

		if (finalPrice < productData.price)
		{
			$priceDisplay.classList.add('xmx-price-display--sale');

			previousPrice = productData.price;
			previousPriceLabel = window.naeAppConfig.i18n.previousPrice;

			if (productData.priceBadge != '')
			{
				var $badge = jQuery('<div>');
				$badge.addClass('xmx-badge');
				$badge.addClass('xmx-badge--special');
				$badge.html(productData.priceBadge);
				$badge.appendTo($priceLine1)
			}
		}
		else 
		{
			if (productData.msrp)
			{
				previousPrice = productData.msrp;
				previousPriceLabel = window.naeAppConfig.i18n.msrp;
			}
		}

		var discountPercent = null;

		if (finalPrice < price)
		{
			discountPercent = -1 * (100 - parseInt(Math.round(finalPrice * 100 / price)));
		}
		else 
		{
			if (msrp)
			{
				discountPercent = -1 * (100 - parseInt(Math.round(finalPrice * 100 / msrp)));
			}
		}

		if (discountPercent > 0)
		{
			discountPercent = null;
		}

		if (previousPrice)
		{
			var $priceLine2 = document.createElement('div');
			$priceLine2.classList.add('xmx-price-line');
			$priceLine2.classList.add('xmx-price-line--previous');
			$priceDisplay.appendChild($priceLine2);

			var $previousPriceLabel = document.createElement('div');
			$previousPriceLabel.classList.add('xmx-price-previous');
			$previousPriceLabel.innerText = previousPriceLabel;
			$priceLine2.appendChild($previousPriceLabel);

			var $previousPriceAmount = document.createElement('div');
			$previousPriceAmount.classList.add('xmx-price-previous-amount');
			$previousPriceAmount.innerText = XmxApp.formatAmount(previousPrice);
			$priceLine2.appendChild($previousPriceAmount);

			var $discountPercent = document.createElement('div');
			$discountPercent.classList.add('xmx-price-reduction');
			$discountPercent.innerText = '(' + discountPercent.toString() + '%)';
			$priceLine2.appendChild($discountPercent);
		}

		if (basePrice)
		{
			if (basePrice > 0)
			{
				var $priceLine3 = document.createElement('div');
				$priceLine3.classList.add('xmx-price-line');
				$priceLine3.classList.add('xmx-price-line--base');
				$priceDisplay.appendChild($priceLine3);

				var $basePrice = document.createElement('div');
				$basePrice.classList.add('xmx-price-unit');

				if (productData.baseUnitValue == 1)
				{
					$basePrice.innerText = XmxApp.formatAmount(basePrice) + ' / ' + productData.baseUnitMeasure;
				}
				else 
				{
					$basePrice.innerText = XmxApp.formatAmount(basePrice) + ' / ' + XmxApp.formatUnit(productData.baseUnitValue, productData.baseUnitMeasure);
				}

				$priceLine3.appendChild($basePrice);
			}
		}

		// Add the Klarna Delbetalning info, if present
		if (productData.klarnaPayment)
		{
			var $klarnaPaymentHint = document.createElement('div');
			$klarnaPaymentHint.classList.add('xmx-product-detail-price-klarna');

			var $klarnaLogo = document.createElement('img');
			$klarnaLogo.classList.add('xmx-product-detail-price-klarna-logo');
			$klarnaLogo.setAttribute('src', '/static/expresscheckout/logo-klarna-2020.svg');
			$klarnaLogo.setAttribute('height', 24);
			$klarnaLogo.setAttribute('width', 56);
			$klarnaLogo.setAttribute('alt', 'Klarna');
			$klarnaPaymentHint.appendChild($klarnaLogo);

			var $klarnaLabel = document.createElement('div');
			$klarnaLabel.classList.add('xmx-product-detail-price-klarna-text');
			$klarnaLabel.innerText = 'Dela upp och betala månadsvis.';
			$klarnaPaymentHint.appendChild($klarnaLabel);
		}
    }

    /**
     * A slide has changed
     */
    function onSwiperSlideChange()
    {
    	// This fires on initialization as well, but our member is not set yet
    	if (_swiper == null)
    	{
    		return;
    	}

    	// Unselect all thumbnails
    	jQuery('> div', $_thumbnails).removeClass('xmx-product-image-thumbnail--selected');

    	// Select the current one
    	jQuery('> div[data-media-index="' + _swiper.realIndex + '"]', $_thumbnails).addClass('xmx-product-image-thumbnail--selected');

		// Track the impression
		trackProductImageImpression(_swiper.realIndex);
    }

	/**
	 * 
	 * @param {*} index 
	 */
	function trackProductImageImpression()
	{
		/*
		var postData = 
		{
			'p': _selectedProductId,
			'i': index,
			't': _fancyBoxSlides.length
		};

		jQuery.ajax
		({
			url: '/ajax/track/pii',
			dataType: 'json',
			type: 'post',
			cache: false,
			data: postData
		});	
		*/
	}

    /**
     * User has clicked on a the large display image
     */
    function onSwiperSlideClick(event)
    {
        // If this is not the left mouse button, get out of here.
        // Mouse button 3 or any mouse back buttons are not functional
        // otherwise.
        if (typeof(event.button) !== 'undefined')
        {
            if (event.button != 0)
            {
                return false;
            }
        }

		// May not look at spoilers
		var image = _configuration.productData[_selectedProductId].images[_swiper.realIndex];

		if (typeof image !== 'undefined')
		{
			if (image.spoilerAlert)
			{
				return false;
			}
		}

		jQuery.fancybox.open
		(
		    _fancyBoxSlides,
		    _fancyBoxOptions,
		    _swiper.realIndex
		);

        event.stopPropagation();

        return false;
    }

    /**
     * If there is no swiper, open the image directly when the user clicked on it
     */
    function onMainImageClick()
    {
		jQuery.fancybox.open
		(
		    _fancyBoxSlides,
		    _fancyBoxOptions,
		    0
		);
    }

    /**
     * A user has a clicked on an image thumbnail
     */
    function onThumbnailClick()
    {
    	var $thumbnail = jQuery(this);
    	var mediaIndex = $thumbnail.data('media-index');

		_swiper.slideToLoop(mediaIndex);
    }

    /**
     * Updates the gallery UI
     */
    function updateGallery()
    {
    	var productData = _configuration.productData[_selectedProductId];
    	var imageData;
        var lastImage;
    	var $thumbnail;
    	var $thumbnailImage;
        var $thumbnailPicture;
        var $mobileThumbnailSource;
        var $desktopThumbnailSource;
    	var mediaIndex = 0;
    	var totalNumberOfSlides = 0;
        var $swiperContainer;
        var $swiperButtonNext;
        var $swiperButtonPrevious;
        var $swiperWrapper;
        var $swiperSlide;
        var $videoTitle;
        var $videoIcon;
        var $swiperImage;
        var $swiperPicture;
        var $swiperImageSource;
        var galleryImage;

    	// If there is a swiper, kill it
    	if (_swiper != null)
    	{
    		_swiper.destroy();
    		_swiper = null;
    	}

    	// Rebuild the thumbnails and display images
    	$_thumbnails.empty();
    	$_mainImage.empty();

    	// Rebuild the Fancy Box slides
    	_fancyBoxSlides = [];

    	// Add a swiper container to the main image
        $swiperContainer = jQuery('<div>');
        $swiperContainer.addClass('xmx-swiper-container');
        $swiperContainer.attr('id', 'display-swiper-container');
        $swiperContainer.appendTo($_mainImage);

		// Arrow right
		$swiperButtonNext = jQuery('<button>');
		$swiperButtonNext.addClass('xmx-swiper-button');
		$swiperButtonNext.addClass('xmx-swiper-button--next'); 
		$swiperButtonNext.attr('id', 'display-swiper-button-next');
        $swiperButtonNext.attr('type', 'button');
		$swiperButtonNext.appendTo($_mainImage);

		// Arrow left
		$swiperButtonPrevious = jQuery('<button>');
		$swiperButtonPrevious.addClass('xmx-swiper-button');
		$swiperButtonPrevious.addClass('xmx-swiper-button--previous');
		$swiperButtonPrevious.attr('type', 'button');
		$swiperButtonPrevious.attr('id', 'display-swiper-button-prev');
		$swiperButtonPrevious.appendTo($_mainImage);

        // Add a swiper wrappper to the main image swiper container
        $swiperWrapper = jQuery('<div>');
        $swiperWrapper.addClass('xmx-swiper-elements');
        $swiperWrapper.appendTo($swiperContainer);

    	// Add the images
		for (var imageIndex in productData.images)
		{
			imageData = productData.images[imageIndex];

			// Create the thumbnail
			$thumbnail = jQuery('<div>');
			$thumbnail.addClass('xmx-product-image-thumbnail');
			$thumbnail.attr('data-media-index', mediaIndex);

			if (imageIndex == 0)
			{
				$thumbnail.addClass('xmx-product-image-thumbnail--selected');
			}

			if (imageData.spoilerAlert)
			{
				$thumbnail.addClass('xmx-product-image-thumbnail--spoiler');
			}

			$thumbnail.on('click', onThumbnailClick);
			$thumbnail.appendTo($_thumbnails);

            // Responsive thumbnail image
            $thumbnailPicture = jQuery('<picture>');

            $mobileThumbnailSource = jQuery('<source>');
            $mobileThumbnailSource.attr('media', '(max-width: 1279px)');
            $mobileThumbnailSource.attr('srcset', imageData.mobileThumbnailUrl);
            $mobileThumbnailSource.appendTo($thumbnailPicture);

            $desktopThumbnailSource = jQuery('<source>');
            $desktopThumbnailSource.attr('media', '(min-width: 1280px)');
            $desktopThumbnailSource.attr('srcset', imageData.desktopThumbnailUrl);
            $desktopThumbnailSource.appendTo($thumbnailPicture);

			// Add the image to the thumbnail
			$thumbnailImage = jQuery('<img>');
			$thumbnailImage.addClass('xmx-product-image-thumbnail-image');
			$thumbnailImage.attr('src', imageData.desktopThumbnailUrl);
			$thumbnailImage.attr('width', 36);
			$thumbnailImage.attr('height', 36);
			$thumbnailImage.attr('alt', imageData.label);
			$thumbnailImage.appendTo($thumbnailPicture);

            $thumbnailPicture.appendTo($thumbnail);


			// Create a large slide
            $swiperSlide = jQuery('<div>');
            $swiperSlide.addClass('xmx-swiper-element');

			if (imageData.spoilerAlert)
			{
				$swiperSlide.addClass('xmx-swiper-element--spoiler');

				var $spoilerAlert = jQuery('<div>');
				$spoilerAlert.addClass('xmx-swiper-spoiler-alert');
				$spoilerAlert.appendTo($swiperSlide);

				var $spoilerAlertCaption = jQuery('<div>');
				$spoilerAlertCaption.addClass('xmx-caption');
				$spoilerAlertCaption.html(_configuration.translations.spoilerAlertCaption);
				$spoilerAlertCaption.appendTo($spoilerAlert);

				var $spoilerAlertDescription = jQuery('<div>');
				$spoilerAlertDescription.addClass('xmx-short-description');
				$spoilerAlertDescription.html(_configuration.translations.spoilerAlertDescription);
				$spoilerAlertDescription.appendTo($spoilerAlert);

				var $spoilerAlertButton = jQuery('<div>');
				$spoilerAlertButton.addClass('xmx-button');
				$spoilerAlertButton.addClass('xmx-button--ghost');
				$spoilerAlertButton.appendTo($spoilerAlert);
				$spoilerAlertButton.on('click', onSpoilerRevealClick);

				var $spoilerAlertButtonLabel = jQuery('<div>');
				$spoilerAlertButtonLabel.addClass('xmx-button-label');
				$spoilerAlertButtonLabel.html(_configuration.translations.spoilerAlertButton);
				$spoilerAlertButtonLabel.appendTo($spoilerAlertButton);
			}

            $swiperSlide.appendTo($swiperWrapper);

            lastImage = null;
            $swiperPicture = jQuery('<picture>');

            for (var galleryIndex in imageData.gallery)
            {
                galleryImage = imageData.gallery[galleryIndex];
                lastImage = galleryImage;

                $swiperImageSource = jQuery('<source>');
                $swiperImageSource.attr('media', galleryImage.media);
                $swiperImageSource.attr('srcset', galleryImage.src);
                $swiperImageSource.appendTo($swiperPicture);
            }

            if (lastImage)
            {
                // Add the image to the slide
                $swiperImage = jQuery('<img>');
                $swiperImage.addClass('xmx-product-main-image-image');
                $swiperImage.attr('alt', imageData.label);
                $swiperImage.attr('src', lastImage.src);
                $swiperImage.attr('width', 600);
                $swiperImage.attr('height', 600);
                $swiperImage.appendTo($swiperPicture);
            }

            $swiperPicture.appendTo($swiperSlide);

            // Count the slide
            totalNumberOfSlides++;
            mediaIndex++;

			// Add a fancy box slide
			if (imageData.spoilerAlert)
			{
				_fancyBoxSlides.push
				({
					src: imageData.zoomImageUrl,
					type: 'image',
					opts: 
					{
						spoiler: true,
						spoilerCaption: _configuration.translations.spoilerAlertCaption,
						spoilerDescription: _configuration.translations.spoilerAlertDescription,
						spoilerButton: _configuration.translations.spoilerAlertButton
					}
				});
			}
			else 
			{
				_fancyBoxSlides.push
				({
					src: imageData.zoomImageUrl,
					type: 'image',
					opts: {}
				});
			}
		}

		// Remove all image count classes
		$_imageGallery.removeClass(function(index, className)
		{
			return (className.match (/(^|\s)xmx-product-image-gallery--\d+/g) || []).join(' ');
		});


    	// Add a YouTube video, if there is one
        if (productData.videoUrl != '')
        {
        	// Create a video thumbnail
			$thumbnail = jQuery('<div>');
			$thumbnail.addClass('xmx-product-image-thumbnail');
			$thumbnail.addClass('xmx-product-image-thumbnail--video');
			$thumbnail.addClass('xmx-icon-play');
			$thumbnail.attr('data-media-index', mediaIndex);
			$thumbnail.on('click', onThumbnailClick);
			$thumbnail.appendTo($_thumbnails);

			$videoTitle = jQuery('<span>');
			$videoTitle.addClass('xmx-product-image-thumbnail-title');
			$videoTitle.html(_configuration.translations.video);
			$videoTitle.appendTo($thumbnail);

			// Create a large slide
            $swiperSlide = jQuery('<div>');
            $swiperSlide.addClass('xmx-swiper-element');
            $swiperSlide.appendTo($swiperWrapper);

            // Add the main image to the slide
            imageData = productData.images[0];

            lastImage = null;
            $swiperPicture = jQuery('<picture>');

            for (var galleryIndexB in imageData.gallery)
            {
                galleryImage = imageData.gallery[galleryIndexB];
                lastImage = galleryImage;

                $swiperImageSource = jQuery('<source>');
                $swiperImageSource.attr('media', galleryImage.media);
                $swiperImageSource.attr('srcset', galleryImage.src);
                $swiperImageSource.appendTo($swiperPicture);
            }

            if (lastImage)
            {
                // Add the image to the slide
                $swiperImage = jQuery('<img>');
                $swiperImage.addClass('xmx-product-main-image-image');
                $swiperImage.attr('alt', imageData.label);
                $swiperImage.attr('src', lastImage.src);
                $swiperImage.attr('width', 600);
                $swiperImage.attr('height', 600);
                $swiperImage.appendTo($swiperPicture);
            }

            $swiperPicture.appendTo($swiperSlide);

            $videoIcon = jQuery('<div>');
            $videoIcon.addClass('xmx-swiper-video-icon');
            $videoIcon.addClass('xmx-icon-play-white');
            $videoIcon.appendTo($swiperSlide);

            // Count the slide
            totalNumberOfSlides++;
            mediaIndex++;

        	// Add the video to the Fancy Box
            _fancyBoxSlides.push
            ({
                src: productData.videoUrl,
                opts: {}
            });
        }

        $_imageGallery.addClass('xmx-product-image-gallery--' + totalNumberOfSlides);

        // Create a swiper object, but only if there are more than one image
        if (totalNumberOfSlides > 1)
        {
	        _swiper = new Swiper('#display-swiper-container', 
	        {
                containerModifierClass: 'xmx-swiper-container--',
                wrapperClass: 'xmx-swiper-elements',
                slideClass: 'xmx-swiper-element',
                slideActiveClass: 'xmx-swiper-element--active',
                slideVisibleClass: 'xmx-swiper-element--visible',
                slidePrevClass: 'xmx-swiper-element--previous',
                slideNextClass: 'xmx-swiper-element--next',
	            centeredSlides: true,
	            spaceBetween: 24,
	            loopedSlides: totalNumberOfSlides,
	            preventClicksPropagation: true,
	            loop: true,
	            simulateTouch: true,
	            threshold: 0,
	            grabCursor: false,
                navigation:
                {
					nextEl: '#display-swiper-button-next',
					prevEl: '#display-swiper-button-prev',
                    disabledClass: 'xmx-swiper-button--disabled'
                },
	            on: 
	            {
	            	slideChange: onSwiperSlideChange,
	            	click: onSwiperSlideClick
	            }
	        });
        }
        else 
        {
	        jQuery('img', $_mainImage).on('click', onMainImageClick);
        }

		// Track impression of main image
		trackProductImageImpression(0);
    }

	/**
	 * Reveal all images
	 */
	function onSpoilerRevealClick()
	{
		for (var imageIndex in _configuration.productData[_selectedProductId].images)
		{
			_configuration.productData[_selectedProductId].images[imageIndex].spoilerAlert = false;
		}

		jQuery('.xmx-swiper-spoiler-alert', $_mainImage).remove();
		jQuery('.xmx-swiper-element--spoiler', $_mainImage).removeClass('xmx-swiper-element--spoiler');
		jQuery('.xmx-product-image-thumbnail', $_thumbnails).removeClass('xmx-product-image-thumbnail--spoiler');
	}

    /**
     * Updates the stock UI
     */
    function updateStockInformation()
    {
    	if (_configuration.productData[_selectedProductId].stockColor == 'red')
    	{
    		$_productStock.addClass('xmx-stock--critical');
		}
		else 
		{
			$_productStock.removeClass('xmx-stock--critical');
		}

		$_productStock.html(_configuration.productData[_selectedProductId].stockLabel);

		if (_configuration.productData[_selectedProductId].isInStock)
		{
    		// Show the add to cart button
			$_addToCartArea.show();

			// Hide the "Email me when its back area"
			$_outOfStockReminder.hide();

			// Show the fly out
			$_flyOut.show();
		}
		else 
		{
    		// Hide the add to cart button
			$_addToCartArea.hide();

			// Show the "Email me when its back area"
			// But only if it is not discontinued
			if (!_configuration.productData[_selectedProductId].isDiscontinued)
			{
				$_outOfStockReminder.show();
			}

			// Hide the fly out
			$_flyOut.hide();
    	}
    }

    /**
     * Changes to a given product ID
     */
    function changeSelectedProduct(productId)
    {
    	// Do not change twice
    	if (productId == _selectedProductId)
    	{
    		return;
    	}

    	_selectedProductId = productId;

    	// Update the form field
    	$_addToCartFormProduct.val(_selectedProductId);

    	// Update all the things
    	updateGallery();
    	updatePrice();
		updateStockInformation();
		updateFlyout();
		sendGoogleAnalyticsView([_selectedProductId]);

		// Send Impressions to ourselves, right away
		/*global XmxEventQueue*/
		XmxEventQueue.trackEvent('pv', 
		{
			'p': _selectedProductId,
			's': _configuration.productData[_configuration.selectedProductId].isInStock
		});
		
		if (_configuration.productType == 'configurable')
		{
			if (_configuration.superAttributeCode == 'color')
			{
				sendClerkProductView(_selectedProductId);
			}
			else 
			{
				sendClerkProductView(_configuration.productId);
			}
		}
		else 
		{
			sendClerkProductView(_selectedProductId);
		}
    }

    /**
     * The user has clicked on a variant
     */
    function onVariantClick(event)
    {
    	var $variant = jQuery(this);
    	var productId = $variant.data('product-id');
    	var variantData;

    	// Select the variant
    	$_variants.removeClass('xmx-product-variation--selected');
    	$variant.addClass('xmx-product-variation--selected');

    	// Change the name
    	for (var variantIndex in _configuration.variants)
    	{
    		variantData = _configuration.variants[variantIndex];

    		if (variantData.productId == productId)
    		{
    			$_selectedVariantName.html(variantData.optionLabel);
    			break;
    		}
    	}

    	// Change to that variant
    	changeSelectedProduct(productId);

        // Prevent following this link
        event.preventDefault();
    }

    /**
     * The user has clicked on the star rating at the top
     */
    function onProductRatingClick()
    {
    	var $content = $_accordionReviewsInput.next();
    	var scrollOffset = _isDesktop ? 120 : 48;

    	$_accordionReviewsInput.prop('checked', true);

    	jQuery('html,body').animate({scrollTop: $content.offset().top - scrollOffset}, 'slow');
    }

    /**
     * The user has clicked on a "write review" button
     */
    function onWriteReviewButtonClick()
    {
    	$_writeReviewCallout.hide();
    	$_writeReviewArea.show();
    }
    
    /**
    * Public interface
    */
    return { // line break is not allowed here

        /**
         * Constructor, boots the checkout
         */
        construct: function() 
        {
            boot();
        }
    };
})();

// Boot the mobile menu
mshopProductPage.construct();
